import React, { useMemo } from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'
import { LocaleContext } from 'styles/locale-provider'
import SocialIcons from '../../footer/social'
import Slider from '../../slider'
import Terms from '../../footer/terms'
import useWindowSize from 'styles/window-size'

import {
  Left,
  MenuWrap,
  CenterContent,
  Li,
  Item,
  Primary,
  Secondary,
  Bottom,
  BText,
  Copyright,
  Creative,
  MobileLinkContact,
} from './index.styled'

const Menu = ({ onClose, onContactMob }) => {
  const {
    slide1,
    slide2,
    slide3,
    menuContent: { content: links },
  } = useStaticQuery(graphql`
    query MenuQuery {
      slide1: file(relativePath: { eq: "menu/slide-1.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      slide2: file(relativePath: { eq: "menu/slide-2.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      slide3: file(relativePath: { eq: "menu/slide-3.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      menuContent {
        content {
          title
          url
          submenu {
            title
            url
          }
        }
      }
    }
  `)

  const [secondaryHover, setSecondaryHover] = React.useState(null)
  const [primaryHover, setPrimaryHover] = React.useState(null)
  const { isMobile } = useWindowSize()

  const { getI18Url, localeText } = React.useContext(LocaleContext)

  const images = [
    { alt: '', file: slide1 },
    { alt: '', file: slide2 },
    { alt: '', file: slide3 },
  ]

  const currentYear = useMemo(() => new Date().getFullYear(), [])

  const onDestinationMobileClick = (e) => {
    e.preventDefault()
    document.querySelector('.destination-submenu').classList.add('mobile-open')
  }

  const onSecondaryClose = (e) => {
    e.stopPropagation()

    document
      .querySelector('.destination-submenu')
      .classList.remove('mobile-open')

    onClose()
  }

  return (
    <>
      <Left>
        <Slider images={images} pagination={false} delay={3000} />
        <BText>
          <Copyright>
            COPYRIGHT &copy; {currentYear} KANAI. ALL RIGHTS RESERVED.
          </Copyright>
          <Creative>CREATIVE & WEBSITE DBOX</Creative>
        </BText>
      </Left>
      <MenuWrap>
        <CenterContent>
          <Primary>
            {links.map((item, index) => (
              <Li
                key={`menu-item-${index}`}
                className={[
                  'primary',
                  primaryHover && primaryHover !== index + 1
                    ? 'no-pr-hover'
                    : '',
                ].join(' ')}
                onMouseOver={() => setPrimaryHover(index + 1)}
                onMouseLeave={() => setPrimaryHover(null)}
              >
                <Item
                  to={getI18Url(item.url)}
                  onClick={
                    isMobile && index === 0 ? onDestinationMobileClick : onClose
                  }
                >
                  {item.title}
                </Item>
                {item.submenu && index === 0 && (
                  <Secondary className={'destination-submenu'}>
                    <Li
                      key={`menu-item-${index}0`}
                      onClick={onSecondaryClose}
                      className={[
                        secondaryHover && secondaryHover !== 1
                          ? 'no-hover'
                          : '',
                      ].join(' ')}
                      onMouseOver={() => setSecondaryHover(1)}
                      onMouseLeave={() => setSecondaryHover(null)}
                    >
                      <Item to={getI18Url(item.url)} className="secondary">
                        {localeText.overview}
                      </Item>
                    </Li>
                    {item.submenu.map((item, j) => (
                      <Li
                        key={`menu-item-${index}${j + 1}`}
                        onClick={onSecondaryClose}
                        className={[
                          secondaryHover && secondaryHover !== j + 2
                            ? 'no-hover'
                            : '',
                        ].join(' ')}
                        onMouseOver={() => setSecondaryHover(j + 2)}
                        onMouseLeave={() => setSecondaryHover(null)}
                      >
                        <Item to={getI18Url(item.url)} className="secondary">
                          {item.title}
                        </Item>
                      </Li>
                    ))}
                  </Secondary>
                )}
              </Li>
            ))}
          </Primary>
          <Bottom>
            {/*   <Link to={getI18Url('/press/')} onClick={onClose}>
              {localeText.press}
            </Link> */}
            {/* <span />
            <SocialIcons className='header' /> */}
            <MobileLinkContact onClick={onContactMob}>
              {localeText.contact}
            </MobileLinkContact>
          </Bottom>
        </CenterContent>
        <Terms className="menu" onClick={onClose} />
      </MenuWrap>
    </>
  )
}

export default Menu
